<template>
  <div class="p-bio m-bio">

    <div class="s-bio">
      <div class="s-bio-title">
        <ul class="f-xs">
          <li>
            <router-link class="l-rg p-cta" to="/people">People .</router-link>
          </li>
          <li>
            <router-link class="l-rg p-cta" to="/people">&nbsp;&nbsp;&nbsp;X&nbsp;&nbsp;&nbsp;</router-link>
          </li>
        </ul>
      </div>
      <div class="s-bio-scroll">
        <h3 class="f-xs">{{ role }}</h3>
        <div class="s-bio-wrap">
          <div class="f-md s-bio-intro" data-animate="fade">
            <span
              class="s-bio-image-person"
              :style="{
                backgroundImage: `url(/images/people/${$route.params.id}.jpg`
              }"
            ></span>
            <p>{{ intro }}</p>
          </div>
          <p class="f-rg" data-animate="fade"></p>
        </div>
      </div>
    </div>

    <Footer />

  </div>
</template>

<script>
import axios from 'axios';

import Footer from '@/components/footer/footer.vue';

export default {
  components: {
    Footer,
  },
  data() {
    return {
      path: '/',
      role: this.role,
      name: this.name,
      body: this.body,
      intro: this.intro,
      id: this.$route.params.id,
    };
  },
  created() {
    axios.get(`${this.path}json/${this.id}.json`).then((response) => {
      this.role = response.data.role;
      this.intro = response.data.intro;

      this.name = response.data.name.replace(/(?:\r\n|\r|\n)/g, '<br>');
      this.body = response.data.body.replace(/(?:\r\n|\r|\n)/g, '<br>');

      document.querySelector('.s-bio-title li:nth-child(1)').innerHTML = `${this.name}`;
      document.querySelector('.s-bio-wrap .f-rg').innerHTML = `${this.body}`;

      const height = document.querySelector('.p-bio').clientHeight;
      document.body.style.height = height;
    });
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$root.$children[0].scroll) this.$root.$children[0].scroll.pause();

      const h = window.innerHeight - this.$el.querySelector('.s-bio').getBoundingClientRect().height;
      this.$el.querySelector('.s-bio-scroll').style.height = `${h}px`;
    });

    this.keypressHandler = (e) => {
      if (e.which === 27) this.$router.push({ path: '/people' });
    };
    window.addEventListener('keydown', this.keypressHandler);
  },
  beforeDestroy() {
    if (this.$root.$children[0].scroll) this.$root.$children[0].scroll.play();
    window.removeEventListener('keydown', this.keypressHandler);
  },
};
</script>
